import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=40589464&scoped=true"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"
import style0 from "./slider.vue?vue&type=style&index=0&id=40589464&prod&scoped=true&lang=css"
import style1 from "./slider.vue?vue&type=style&index=1&id=40589464&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40589464",
  null
  
)

export default component.exports